import { render, staticRenderFns } from "./joinActivity.vue?vue&type=template&id=00a78ea3&scoped=true"
import script from "./joinActivity.vue?vue&type=script&lang=js"
export * from "./joinActivity.vue?vue&type=script&lang=js"
import style0 from "./joinActivity.vue?vue&type=style&index=0&id=00a78ea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a78ea3",
  null
  
)

export default component.exports